import React from 'react';
import { Result, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

export default function MaintenancePage() {
  const params  = new URLSearchParams(window.location.search);
  const message = params.get('message') || 'The application is currently under maintenance. Please check back soon.';

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
      <Result
        icon={<ToolOutlined style={{ color: '#faad14' }} />}
        title="Under Maintenance"
        subTitle={
          <Typography.Text style={{ fontSize: 15 }}>{message}</Typography.Text>
        }
      />
    </div>
  );
}
